import { StateCreator } from 'zustand';
import { SidePanelSlice, SidePanelSliceState } from './index.types';

const initialState: SidePanelSliceState = {
  sidePanelCustomWidth: null,
  entitySidePanelInfo: null,
  showChatHistory: false,
  videoSummarySidePanelInfo: null,
};

export const createSidePanelSlice: StateCreator<SidePanelSlice> = (set) => ({
  ...initialState,
  setSidePanelCustomWidth: (width) => {
    set({ sidePanelCustomWidth: width });
  },
  setEntitySidePanelInfo: (entitySidePanelInfo) => {
    set({ entitySidePanelInfo });
  },
  resetEntitySidePanel: () => {
    set(() => ({ entitySidePanelInfo: initialState.entitySidePanelInfo }));
  },
  setIsChatHistoryOpen: (isChatHistoryOpen) => {
    set({ showChatHistory: isChatHistoryOpen });
  },
  setVideoSummarySidePanelInfo: (videoSummarySidePanelInfo) => {
    set({ videoSummarySidePanelInfo });
  },
  resetVideoSummarySidePanel: () => {
    set(() => ({
      videoSummarySidePanelInfo: initialState.videoSummarySidePanelInfo,
    }));
  },
});
